import { Trans } from "@lingui/react/macro";
import { Link, Navigate } from "@tanstack/react-router";

import { useCurrentUser } from "../api/useCurrentUser";
import { HowItWorks } from "./HowItWorks";
import { LoginButton } from "./LoginButton";

type LoginScreenProps = {
  next?: string | undefined;
  // Код приглашения из ссылки друга (`/login?ref=…`).
  referralCode?: string | undefined;
};

// Страница входа по макету design/prototype/Login.dc.html: всё на одном экране — слева что это
// и «Как это работает», справа вход. Разбора без входа нет. Уже вошедшего игрока сразу
// возвращает туда, откуда его отправили на вход.
export const LoginScreen = ({ next, referralCode }: LoginScreenProps) => {
  const { data: user } = useCurrentUser();

  if (user) {
    return <Navigate to="/" href={next} replace />;
  }

  return (
    <main
      data-page="login"
      className="mx-auto flex w-full max-w-[1200px] grow flex-wrap content-center items-center gap-10 px-6 pt-6 pb-8"
    >
      <section className="flex min-w-0 flex-[999_1_560px] flex-col gap-4">
        <h1 className="font-display text-[40px] leading-[1.1]">
          <Trans>Find out why you lost the match</Trans>
        </h1>
        <p className="max-w-[62ch] text-base text-foreground-soft">
          <Trans>
            A personal Deadlock coach. It reviews each of your matches and compares you with strong
            players on the same hero. It shows what keeps you from winning, turns your mistakes into
            short drills and makes sure they do not repeat.
          </Trans>
        </p>
        <HowItWorks />
      </section>

      <section
        aria-labelledby="login-heading"
        className="flex max-w-[420px] min-w-0 flex-[1_1_340px] flex-col gap-4 rounded-[14px] border border-border bg-surface p-7"
      >
        <h2 id="login-heading" className="font-display text-[30px]">
          <Trans>Sign in</Trans>
        </h2>
        <LoginButton next={next} referralCode={referralCode} />
        <p className="text-[13px] text-muted">
          <Trans>
            You sign in on the Steam website. We only receive your Steam ID and never see your
            password.
          </Trans>
        </p>
        <p className="text-[13px] text-muted">
          <Trans>
            By signing in, you accept the{" "}
            <Link to="/terms" className="text-accent hover:text-accent-strong">
              user agreement
            </Link>{" "}
            and the{" "}
            <Link to="/privacy" className="text-accent hover:text-accent-strong">
              privacy policy
            </Link>
            .
          </Trans>
        </p>
      </section>
    </main>
  );
};
